// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/img/home/badge-1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/img/home/badge-2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/img/home/badge-3.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-table-row {
  display: flex;
  align-items: center;
  padding: 10px 16px;
}
@media (max-width: 740px) {
  .home-table-row {
    flex-wrap: wrap;
    padding-left: 0;
    padding-right: 0;
  }
}
.home-table-row:nth-child(1) .home-table-row__number, .home-table-row:nth-child(2) .home-table-row__number, .home-table-row:nth-child(3) .home-table-row__number {
  color: #fff;
  background: no-repeat center;
}
.home-table-row:nth-child(1) .home-table-row__number {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.home-table-row:nth-child(2) .home-table-row__number {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.home-table-row:nth-child(3) .home-table-row__number {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.home-table-row__number {
  width: 28px;
  height: 28px;
  font-weight: 700;
  font-size: 14px;
  line-height: 28px;
  color: #838da4;
  text-align: center;
  margin-right: 10px;
}
@media (max-width: 740px) {
  .home-table-row__number {
    order: 1;
  }
}
.home-table-row__name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 200px;
  margin-right: 12px;
}
@media (max-width: 740px) {
  .home-table-row__name {
    order: 2;
    flex: 1 1;
    width: auto;
  }
}
.home-table-row__progress {
  flex: 1 1;
  height: 24px;
  background: #d9d9d9;
  border-radius: 5px;
  padding-right: 35px;
  margin-right: 12px;
  position: relative;
}
@media (max-width: 740px) {
  .home-table-row__progress {
    order: 4;
    flex: initial;
    width: 100%;
    margin: 10px 0 0 38px;
  }
}
.home-table-row__progress-line {
  height: 100%;
  background: #8cd274;
  border-radius: inherit;
}
.home-table-row__progress-number {
  width: 40px;
  border-radius: inherit;
  text-align: center;
  font-size: 12px;
  line-height: 24px;
  background: #ff3900;
  color: #fff;
  position: absolute;
  top: 0;
  right: 0;
}
.home-table-row__sum {
  font-weight: 600;
  font-size: 18px;
  line-height: 133%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 200px;
  color: #828ea6;
  text-align: right;
}
@media (max-width: 740px) {
  .home-table-row__sum {
    order: 3;
    width: 100%;
    text-align: left;
    padding-left: 38px;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/home/features/homeTableRow/homeTableRow.scss","webpack://./src/sass/mixins/_adaptive.scss","webpack://./src/sass/mixins/_typography.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;ACyDI;ED1DJ;IAKQ,eAAA;IACA,eAAA;IACA,gBAAA;EAAN;AACF;AAIQ;EACI,WAAA;EACA,4BAAA;AAFZ;AAKI;EACI,yDAAA;AAHR;AAKI;EACI,yDAAA;AAHR;AAKI;EACI,yDAAA;AAHR;AAMI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAJR;AC2BI;ED/BA;IAUQ,QAAA;EAFV;AACF;AAKI;EElBA,uBAAA;EACA,gBAAA;EACA,mBAAA;EFkBI,YAAA;EACA,kBAAA;AADR;ACeI;EDjBA;IAKQ,QAAA;IACA,SAAA;IACA,WAAA;EACV;AACF;AAEI;EACI,SAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAAR;ACDI;EDNA;IASQ,QAAA;IACA,aAAA;IACA,WAAA;IACA,qBAAA;EAEV;AACF;AAAQ;EACI,YAAA;EACA,mBAAA;EACA,sBAAA;AAEZ;AACQ;EACI,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;AACZ;AAGI;EEvFA,gBAAA;EACA,eAAA;EACA,iBAAA;EAqBA,uBAAA;EACA,gBAAA;EACA,mBAAA;EFiEI,YAAA;EACA,cAAA;EACA,iBAAA;AAGR;ACrCI;ED6BA;IAOQ,QAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;EAKV;AACF","sourcesContent":["@import 'src/sass/common/variables';\n@import 'src/sass/mixins';\n\n.home-table-row {\n    display: flex;\n    align-items: center;\n    padding: 10px 16px;\n    @include mobile {\n        flex-wrap: wrap;\n        padding-left: 0;\n        padding-right: 0;\n    }\n    &:nth-child(1),\n    &:nth-child(2),\n    &:nth-child(3) {\n        .home-table-row__number {\n            color: #fff;\n            background: no-repeat center;\n        }\n    }\n    &:nth-child(1) .home-table-row__number {\n        background-image: url(/assets/img/home/badge-1.svg);\n    }\n    &:nth-child(2) .home-table-row__number {\n        background-image: url(/assets/img/home/badge-2.svg);\n    }\n    &:nth-child(3) .home-table-row__number {\n        background-image: url(/assets/img/home/badge-3.svg);\n    }\n\n    &__number {\n        width: 28px;\n        height: 28px;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 28px;\n        color: #838da4;\n        text-align: center;\n        margin-right: 10px;\n        @include mobile {\n            order: 1;\n        }\n    }\n\n    &__name {\n        @include textWithDots;\n        width: 200px;\n        margin-right: 12px;\n        @include mobile {\n            order: 2;\n            flex: 1;\n            width: auto;\n        }\n    }\n\n    &__progress {\n        flex: 1;\n        height: 24px;\n        background: #d9d9d9;\n        border-radius: 5px;\n        padding-right: 35px;\n        margin-right: 12px;\n        position: relative;\n        @include mobile {\n            order: 4;\n            flex: initial;\n            width: 100%;\n            margin: 10px 0 0 38px;\n        }\n\n        &-line {\n            height: 100%;\n            background: #8cd274;\n            border-radius: inherit;\n        }\n\n        &-number {\n            width: 40px;\n            border-radius: inherit;\n            text-align: center;\n            font-size: 12px;\n            line-height: 24px;\n            background: #ff3900;\n            color: #fff;\n            position: absolute;\n            top: 0;\n            right: 0;\n        }\n    }\n\n    &__sum {\n        @include h4;\n        @include textWithDots;\n        width: 200px;\n        color: #828ea6;\n        text-align: right;\n        @include mobile {\n            order: 3;\n            width: 100%;\n            text-align: left;\n            padding-left: 38px;\n        }\n    }\n}\n","@import 'src/sass/common/variables';\n\n@mixin media($min-width: false, $max-width: false) {\n    @if $min-width and $max-width {\n        @media screen and (min-width: $min-width) and (max-width: $max-width) {\n            @content;\n        }\n    } @else if $min-width and not $max-width {\n        @media screen and (min-width: $min-width) {\n            @content;\n        }\n    } @else if $max-width and not $min-width {\n        @media screen and (max-width: $max-width) {\n            @content;\n        }\n    }\n}\n\n@mixin fullhd {\n    @media (min-width: #{$large}) {\n        @content;\n    }\n}\n\n@mixin desktop {\n    @media (min-width: #{$medium}) {\n        @content;\n    }\n}\n\n@mixin desktop-tablet {\n    @media (min-width: #{$small}) {\n        @content;\n    }\n}\n\n@mixin laptop {\n    @media (max-width: #{$large}) and (min-width: #{$medium}) {\n        @content;\n    }\n}\n\n@mixin laptop-tablet {\n    @media (max-width: #{$large}) and (min-width: #{$small}) {\n        @content;\n    }\n}\n\n@mixin laptop-mobile {\n    @media (max-width: #{$large}) {\n        @content;\n    }\n}\n\n@mixin tablet {\n    @media (max-width: #{$medium}) and (min-width: #{$small}) {\n        @content;\n    }\n}\n\n@mixin mobile {\n    @media (max-width: #{$small}) {\n        @content;\n    }\n}\n\n@mixin tablet-mobile {\n    @media (max-width: #{$medium}) {\n        @content;\n    }\n}","@import 'src/sass/common/variables';\n\n@mixin h4 {\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 133%;\n}\n\n@mixin title1 {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 133%;\n}\n\n@mixin body1 {\n    font-size: 14px;\n    line-height: 171%;\n    font-weight: 600;\n}\n\n@mixin caption {\n    @include body1;\n    font-weight: 800;\n}\n\n@mixin textWithDots {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
